import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import {
  getUserPreferencesApiThunk,
  updateUserPreferencesApiThunk,
  linkSlackIdentityApiThunk,
  clearUserPreferencesMessages,
  resetUpdateApiStatus,
} from './userPreferencesSlice';
import { RootState } from '..';
import { LinkSlackIdentityCommandInput } from '@amzn/gbsa-orbit-typescript-client';
import {
  GetUserPreferencesRequest,
  UpdateUserPreferencesRequest,
} from 'src/types/orbit/UserPreferences';

export const useUserPreferences = () => {
  const dispatch = useAppDispatch();
  const userPreferences = useAppSelector(
    (state: RootState) => state.userPreferences.userPreferences,
  );
  const getUserPreferencesApiStatus = useAppSelector(
    (state: RootState) => state.userPreferences.getUserPreferencesApiStatus,
  );
  const updateUserPreferencesApiStatus = useAppSelector(
    (state: RootState) => state.userPreferences.updateUserPreferencesApiStatus,
  );
  const linkSlackIdentityApiStatus = useAppSelector(
    (state: RootState) => state.userPreferences.linkSlackIdentityApiStatus,
  );

  const loadUserPreferences = useCallback(
    (data: GetUserPreferencesRequest) => {
      dispatch(getUserPreferencesApiThunk(data));
    },
    [dispatch],
  );

  const updateUserPreferences = useCallback(
    (data: UpdateUserPreferencesRequest) => {
      dispatch(updateUserPreferencesApiThunk(data));
    },
    [dispatch],
  );

  const linkSlackIdentity = useCallback(
    (data: LinkSlackIdentityCommandInput) => {
      dispatch(linkSlackIdentityApiThunk(data));
    },
    [dispatch],
  );

  const clearAllUserPreferencesApiMessages = useCallback(() => {
    dispatch(clearUserPreferencesMessages());
  }, [dispatch]);

  const resetUpdateStatus = useCallback(() => {
    dispatch(resetUpdateApiStatus());
  }, [dispatch]);

  return {
    userPreferences,
    getUserPreferencesApiStatus,
    updateUserPreferencesApiStatus,
    linkSlackIdentityApiStatus,
    loadUserPreferences,
    updateUserPreferences,
    linkSlackIdentity,
    clearAllUserPreferencesApiMessages,
    resetUpdateStatus,
  };
};
